import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

/**
 * Used for IDC rate calculations
 *
 * TODO: get better description
 */
export enum LibraryUserCategory {
  Faculty = 'FAC',
  HospitalUsers = 'HOSP',
  Other = 'OTHER',
  Student = 'STU',
  WorkingGraduateStudent = 'WGS',
}
// Needs to be before namespace is defined
const LIBRARY_CATEGORIES: ReadonlySet<LibraryUserCategory> = new Set(
  Object.values(LibraryUserCategory) as LibraryUserCategory[],
)
export namespace LibraryUserCategory {
  export const ALL: readonly LibraryUserCategory[] =
    Array.from(LIBRARY_CATEGORIES)
  export const isLibraryUserCategory =
    TypeChecker.Factory.oneOf(LIBRARY_CATEGORIES)
  export const assertIsLibraryUserCategory: TypeAsserter<LibraryUserCategory> =
    TypeAsserter.Factory.from(isLibraryUserCategory)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link LibraryUserCategory}
   */
  export function getEntry(
    libraryUserCategory: LibraryUserCategory,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[libraryUserCategory], id: libraryUserCategory }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    LibraryUserCategory,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [LibraryUserCategory.Faculty]: {
      name: 'Faculty & Professional',
    },
    [LibraryUserCategory.HospitalUsers]: {
      name: 'Hospital Users',
    },
    [LibraryUserCategory.Other]: {
      name: 'Other Users',
    },
    [LibraryUserCategory.Student]: {
      name: 'Students',
    },
    [LibraryUserCategory.WorkingGraduateStudent]: {
      name: 'Working Graduate Student',
    },
  }

  /**
   * Retrieves a user-friendly name for the given {@link LibraryUserCategory}
   */
  export function getName(libraryUserCategory: LibraryUserCategory): string {
    return getEntry(libraryUserCategory).name
  }
}
